module.exports = __webpack_public_path__ + "static/media/Medal.d25b22e7.png";